<template>
  <div class="questionnaire-question-all-type">
    <div :class="[`questionnaire-question-${display}`, `-${type}-`, advancedClass]">
      <template v-for="(question, index) in option">
        <UiButton
          :key="index"
          class="-blue-gray-"
          :class="[`questionnaire-question-${display}__item`,{'-active-': question.id === localNumberValue}]"
          @click="setActive(question.id)"
        >
          {{ question.title }}
        </UiButton>
      </template>
    </div>
    <div :class="`questionnaire-question-${type}`"
         v-if="type === 'business-categories'">
      <div :class="`questionnaire-question-${type}__input`">
        <UiInput
            class="questionnaire-question-grid__item"
            :height="51"
            title="Чистая прибыль"
            placeholder="Введи данные"
            :value="localTextValue"
            @input="setText"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    option: {},
    value: {},
    type: {},
    display: {},
    advancedClass: {}
  },
  data() {
    return {
      localTextValue: '',
      localNumberValue: null
    }
  },
  watch: {
    // whenever question changes, this function will run
    value(value) {
      this.initData(value)
    }
  },
  mounted() {
    this.initData(this.value)
  },
  methods: {
    initData(value) {
      if (Number.isInteger(value) || this.type !== 'business-categories') {
        this.localNumberValue = value
      } else {
        this.localTextValue = value
      }
    },
    setActive(id) {
      this.localNumberValue = id
      this.localTextValue = ''
      this.$emit('input', id)
    },
    setText(value) {
      this.localTextValue = value
      this.localNumberValue = null
      this.$emit('inputText', value)
    }
  }
};
</script>
